// WARNING: DO NOT EDIT. This file is automatically generated.

const awsConfig = {
    "region": "eu-west-1",
    "stage": "prod",
    "accountName": "sky",
    "api_url": "https://5mjizilxzj.execute-api.eu-west-1.amazonaws.com/prod/graphql",
    "notifications_api_url": "https://5mjizilxzj.execute-api.eu-west-1.amazonaws.com/prod/notifications",
    "run_daily_test_url": "https://zz0efhby63.execute-api.eu-west-1.amazonaws.com/prod/run-daily-test",
    "sport_highlights_url": "https://v44kkdljancgfis2ftqgzjmro4.appsync-api.eu-west-1.amazonaws.com/graphql",
    "appconfig_url": "https://5mjizilxzj.execute-api.eu-west-1.amazonaws.com/prod/getConfig",
    "direct_appconfig_url": "https://3oouk2yyt1.execute-api.eu-west-1.amazonaws.com/prod",
		"endpoint_url" : "https://5mjizilxzj.execute-api.eu-west-1.amazonaws.com/prod",
    "mgmt_ui_appconfig_dropdown_profile": "mgmt-ui-dropdown-options",
    "mgmt_ui_appconfig_configs_profile": "mgmt-ui-configs",
    "daily-test-game-configs": "daily-testing-configs",
    "leagues": "leagues",
    "aws_project_region": "eu-west-1",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_div37T7IJ",
    "aws_user_pools_web_client_id": "6a1ka1qrmu1gdg3ofv9pagu2c4",
    "oauth": {
        "domain": "spex-mgmt-ui-hosting-prod.auth.eu-west-1.amazoncognito.com",
        "scope": [
          "phone",
          "email",
          "profile",
          "openid",
          "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://mgmt.spex.aidisco.sky.com",
        "redirectSignOut": "https://mgmt.spex.aidisco.sky.com",
        "responseType": "code"
    },
    "defaultChannelName": "ExternalSLE",
    "playfactoryLicenseAcquisitionEndpointUrl": "",
    "arcusLicenseAcquisitionEndpointUrl": "",
    "viperProxyUrl": "https://d1iz38lz8tkdp6.cloudfront.net"
};

export default awsConfig;

